var React = require('react');

function Doors (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M30.5 24.3c0 2.33-1.924 4.2-4.278 4.2H8.205c-1.976 0-3.746-1.218-4.412-3.054l-1.87-5.156c-.926-2.554-.306-5.399 1.6-7.364l5.441-5.61A9.345 9.345 0 0 1 15.67 4.5H30.5v19.8zm-3-16.8H15.67a6.345 6.345 0 0 0-4.552 1.905l-5.443 5.61c-1.108 1.143-1.465 2.78-.93 4.252l1.869 5.157c.231.639.867 1.076 1.591 1.076h18.017c.716 0 1.278-.547 1.278-1.2V7.5zm-11.571 3.722a3.33 3.33 0 0 0-2.473 1.118l-2.598 2.882H24v-4h-8.071zm10.071-2v8H9.269c-1.106 0-1.68-1.36-.928-2.195l3.63-4.026a5.33 5.33 0 0 1 3.958-1.78H26zM21 18.5h5v.913c0 .6-.55 1.087-1.23 1.087h-2.54c-.68 0-1.23-.487-1.23-1.087V18.5z"}));
}

Doors.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Doors;

Doors.default = Doors;
